const TEXT = {
    COMMON: {
        MOBILENUMBER: "Telefonnummer",
    },
    PERSONAL_DETAILS: {
        HEADING: "Opplysninger",
        HARDWARE_ONLY: {
            ORG_HEADING: "Informasjon om bedriften",
            CONTACT_PERSON_HEADING: "Kontaktperson",
        },
        USE_POST_BOX: "Postboksadresse?",
        FIRSTNAME: "Fornavn",
        LASTNAME: "Etternavn",
        BIRTHDATE: "Fødselsdato (ddmmåååå)",
        STREET_CO: "C/O",
        STREET_CO_HELPTEXT: "Benyttes hvis firmanavn ikke står på postkassen.",
        STREET: "Adresse",
        PB_NUMBER: "Postboksnummer",
        PB_NAME: "Postboksanlegg",
        PB_NAME_HELPTEXT: "Benyttes om by/sted har flere anlegg",
        POSTCODE: "Postnummer",
        CITY: "Poststed",
        EMAIL: "E-post",
    },
    SUMMARY: {
        HEADING: "Levering",
        RECEIVER: "Mottaker",
    },
    ORDER: {
        HEADING: "Bestilling",
    },
    RECEIPT: {
        HEADING: "Kvittering",
        THANKS: (name: string) => `Takk for bestillingen, ${name}!`,
        EMAIL_CONFIRMATION: "Bekreftelse blir sendt på e-post.",
        TRACKING_SMS: "Du får sporingsnummer tilsendt når varene forlater vårt lager.",
        DELIVERY: "Leveringsmetode/-sted",
        DELIVERY_DATE: "Estimert leveringsdato",
        CONTACT_INFO: "Kontaktinformasjon",
        CONTACT_PHONE: "Telefonnummer",
        CONTACT_EMAIL: "E-postadresse",
        CREDENTIALS: "Husk gyldig legitimasjon ved utlevering av varene.",
        ORDER_BY: "Bestilt av",
        ORDER_NUMBER: "Ordrenummer",
        ORDER_TYPE: "Bestillingstype",
        UPGRADE: "Oppgradering",
        UPGRADE_TIME: "Umiddelbart",
        TERMS_AND_AGREEMENT: "Vilkår og avtaler",
    },
    ERROR: {
        POST_ADDRESS_UNAVAILABLE: "Beklager, vi kan ikke sende til postnummeret du har oppgitt.",
        ORDER_SUBMIT: "Beklager, noe gikk galt med din bestilling ",
        DELETE_PRODUCT: "Beklager, kunne ikke gjennomføre sletting av produkt.",
        PAYMENT: "Betalingen din ble ikke gjennomført. Mest sannsynligvis ble den avvist av banken din.",
        NO_SHOP_CHOSEN: "Klikk & Hent er valgt uten å velge en butikk. Vennligst velg en butikk for å gå videre.",
        NO_PICK_UP_POINT_CHOSEN:
            "Post i butikk er valgt uten å velge en butikk. Vennligst velg en butikk for å gå videre.",
    },
    B2B_MANUAL_ORDER: {
        ORDERER_CARD: {
            HEADING: "Eier og bestiller",
            FORM: {
                PICK_COMPANY_HEADING: "Velg hvilket selskap som skal stå som eier av bestillingen:",
                ORDERER_PERSONALIA_HEADING: "Hvem er ansvarlig for bestillingen?",
                SIGNATURE_REMINDER:
                    "NB! Personen må ha signeringsrett fra selskapet for at vi kan gjennomføre bestillingen.",
                CHANGE_COMPANY: "Endre selskap",
                ORG_NUMBER_LABEL: "Org.nummer:",
            },
        },
        PRODUCT_CARD: {
            HEADING: "Produkter",
            FORM: {
                HEADING_HW: (isMbb: boolean) => (isMbb ? "Router: " : "Mobiltelefon: "),
                PHONE_PRICE: (price: number) => `Pris: ${price},-/md (eks mva)`,
                ROUTER_PRICE: (price: number) => `Pris: ${price},- (eks mva)`,
                HEADING_SUBSCRIPTION: "Abonnement",
                INSURANCE: "Oppgrader til Plussforsikring (+99,-/md)",
                WEBDEAL: `Inkludert`,
            },
            ADD_SUBSCRIPTION: "Legg til abonnement",
            EDIT_HW: (isMbb: boolean) => (isMbb ? "Endre router" : "Endre telefon"),
            NEW_NUMBER: "Bestill nytt mobilnummer",
        },
        DELIVERY_CARD: {
            HEADING: "Levering og faktura",
            DELIVERY: "Leveringadresse",
            DELIVERY_DESCRIPTION:
                "Alle bestillinger sendes med Posten Bedriftspakke og er kostnadsfritt. Sporingsnummer blir sendt på e-post eller SMS.",
            SUMMARY: "Oppsummering (alle priser er eks mva)",
            FIRST_INVOICE: "Første faktura",
            EMAIL_INVOICE: "Hvilken e-post skal faktura sendes til?",
            MONTHLY_COST_LABEL: "Totalt pr md:",
            UPFRONT_COST_LABEL: "Totalt å betale nå:",
        },
        SUBMIT: {
            INGRESS: "Ved å trykke Bestill godkjenner du at vi gjennomfører en kredittsjekk.",
            BUTTON: "Bestill",
        },
    },
} as const;

export default TEXT;
